import React from 'react';
import { useNavigate } from 'react-router-dom';

function Write() {
    const navigate = useNavigate();

    function goToCreateDevice() {
        navigate('/atsg/write/create_device');
    }
    function goToSetRecoveryEmail() {
        navigate('/atsg/write/set_recov_email');
    }
    function goToSetRecoveryPhone() {
        navigate('/atsg/write/set_recov_phone');
    }
    function goToCleanHungLicenses() {
        navigate('/atsg/write/clean_hung_licenses');
    }

    function goToCleanDuplicateLicenses() {
        navigate('/atsg/write/clean_duplicate_licenses');
    }
    function goToHome() {
        navigate('/atsg/home');
    }
    function goBack() {
        navigate('/atsg/home'); // Navigate to the previous page
    }

    return (
        <>
            <div className="menu-box shadow-xl shadow-cyan-500/30">
                <div className='menu-title underline underline-offset-2 '>
                    <h2>
                        Create or Update Resource
                    </h2>
                    </div>
                    
                    <div className='center-box shadow-xl shadow-cyan-500/30'>
                    {/*  <<<<<=== SAAS team asked to hide this button.  ===>>>>>
                        <button
                            onClick={goToCreateDevice}
                            className={"center-button shadow-xl rounded-md shadow-cyan-500/30"}
                            >
                            Create a Device
                        </button>
                        */}
                        <button
                            onClick={goToSetRecoveryEmail}
                            className={"center-button shadow-xl rounded-md shadow-cyan-500/30"}
                            >
                            Set Recovery Email
                        </button>
                        <button
                            onClick={goToSetRecoveryPhone}
                            className={"center-button shadow-xl rounded-md shadow-cyan-500/30"}
                            >
                            Set Recovery Phone
                        </button>
                    {/*
                        <button
                            onClick={goToCleanHungLicenses}
                            className={"center-button"}
                            >
                            Clean Hung Licenses
                        </button>
                        <button
                            onClick={goToCleanDuplicateLicenses}
                            className={"center-button"}
                            >
                            Clean Duplicate Licenses
                        </button>
                        */}
                    </div> 
                    
                    <div className='foot-box'>
                        <button
                            onClick={goBack}
                            className={"foot-button"}
                        >
                            Back
                        </button>
                        <button
                            onClick={goToHome}
                            className={"foot-button"}
                        >
                            Home
                        </button>
                    </div>
                </div>
        </>
    );
}

export default Write;